
export enum codes {
  ERR_INVALID_PARAMETERS = 'ERR_INVALID_PARAMETERS',
  ERR_INVALID_KEY_NAME = 'ERR_INVALID_KEY_NAME',
  ERR_INVALID_KEY_TYPE = 'ERR_INVALID_KEY_TYPE',
  ERR_KEY_ALREADY_EXISTS = 'ERR_KEY_ALREADY_EXISTS',
  ERR_INVALID_KEY_SIZE = 'ERR_INVALID_KEY_SIZE',
  ERR_KEY_NOT_FOUND = 'ERR_KEY_NOT_FOUND',
  ERR_OLD_KEY_NAME_INVALID = 'ERR_OLD_KEY_NAME_INVALID',
  ERR_NEW_KEY_NAME_INVALID = 'ERR_NEW_KEY_NAME_INVALID',
  ERR_PASSWORD_REQUIRED = 'ERR_PASSWORD_REQUIRED',
  ERR_PEM_REQUIRED = 'ERR_PEM_REQUIRED',
  ERR_CANNOT_READ_KEY = 'ERR_CANNOT_READ_KEY',
  ERR_MISSING_PRIVATE_KEY = 'ERR_MISSING_PRIVATE_KEY',
  ERR_INVALID_OLD_PASS_TYPE = 'ERR_INVALID_OLD_PASS_TYPE',
  ERR_INVALID_NEW_PASS_TYPE = 'ERR_INVALID_NEW_PASS_TYPE',
  ERR_INVALID_PASS_LENGTH = 'ERR_INVALID_PASS_LENGTH'
}
